import React from 'react';
import { TrustBar } from './TrustBar';
import { Services } from './Services';
import { Comparison } from './Comparison';
import { ProblemSolution } from './ProblemSolution';
import { DoorGlass } from './DoorGlass';
import { Process } from './Process';
import { ShowerGlass } from './ShowerGlass';
import { Mirrors } from './Mirrors';
import { DeckScreens } from './DeckScreens';
import { WhyChooseUs } from './WhyChooseUs';
import { ServiceArea } from './ServiceArea';
import { ResidentialGlassFAQ } from '../../components/ResidentialGlassFAQ/ResidentialGlassFAQ';
import { ServiceReview } from '../../../components/PageIntro';
export function ResidentialGlass() {
  return <div className="legacy-sections" data-id="element-1269" data-mp="37lj5vk1der85">
<TrustBar data-id="element-1270" data-mp="3cm74aqrxiace" />
<Services data-id="element-1271" data-mp="3clxep4asq578" />
<ServiceReview index={2} data-id="element-1272" data-mp="3cnrygfabzr9q" />
<Comparison data-id="element-1273" data-mp="3cmynt3894hmb" />
<ProblemSolution data-id="element-1274" data-mp="3ckci794x8c6q" />
<DoorGlass data-id="element-1275" data-mp="2xppu42vh71rf" />
<Process data-id="element-1276" data-mp="2xoxywt5sj61o" />
<ShowerGlass data-id="element-1277" data-mp="2xp6bsl1wybcv" />
<Mirrors data-id="element-1278" data-mp="2xqr6qbs53wb9" />
<DeckScreens data-id="element-1279" data-mp="2xpzk3qgit8x4" />
<WhyChooseUs data-id="element-1280" data-mp="2xrj2pnpnfw22" />
<ServiceArea data-id="element-1281" data-mp="2xrsk4mwmouw5" />
<ResidentialGlassFAQ data-id="element-1282" data-mp="32o9ie9xjkpmy" />
</div>;
}